import React from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

import Avatar from "../../../assets/Avatar";
import ImageWithFallback from "../../../assets/ImageWithFallback";

import styles from "./styles/SuggestionEntry.sass";

const cx = classNames.bind(styles);

export const SuggestionEntry = ({ mention, theme, searchValue, isFocused, ...parentProps }) => {
  const { name, type, info, poster } = mention;

  return (
    <div {...parentProps}>
      <div className={cx("wrapper", theme)}>
        <div className={cx("image")}>
          {type === "Person" ? (
            <Avatar {...poster} username={name} width={42} />
          ) : (
            <ImageWithFallback {...poster} alt={name} width={42} type={type} aspectRatio={0.6979} />
          )}
        </div>
        <div className={cx("details")}>
          <div className={cx("title")}>
            {name}
          </div>
          <div className={cx("meta", { isSmall: type === "Person" })}>
            {info}
          </div>
        </div>
      </div>
    </div>
  );
};

SuggestionEntry.propTypes = {
  mention: PropTypes.object,
  theme: PropTypes.object,
  searchValue: PropTypes.string,
  isFocused: PropTypes.bool,
};

SuggestionEntry.defaultProps = {
  mention: {},
  theme: {},
  searchValue: null,
  isFocused: false,
};

export default SuggestionEntry;
